import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

const AutoComplete = ({
  sx,
  label,
  labelKey = "name",
  fetchOptions,
  onChange,
  multiple = true,
  value,
  getOptionLabel,
  sessionKey,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const fetchOptionsRef = useRef(fetchOptions);
  fetchOptionsRef.current = fetchOptions;

  useEffect(() => {
    setOpen(false);
    setInputValue("");
    setSearchTerm("");
    setOptions([]);
  }, [sessionKey]);

  useEffect(() => {
    if (!open) return;

    let active = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await fetchOptionsRef.current(searchTerm);
        if (active) setOptions(result || []);
      } catch (err) {
        console.error("Error fetching options:", err);
        if (active) setOptions([]);
      }
      if (active) setLoading(false);
    };

    fetchData();
    return () => {
      active = false;
    };
  }, [searchTerm, open]);

  return (
    <Autocomplete
      isOptionEqualToValue={(option, value) => option.id === value.id}
      sx={sx}
      fullWidth
      value={value || []}
      multiple={multiple}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={(event, reason) => {
        if (reason !== "selectOption") {
          setOpen(false);
          setInputValue("");
          setSearchTerm("");
        }
      }}
      disableCloseOnSelect
      inputValue={inputValue}
      onInputChange={(event, newInputValue, reason) => {
        if (reason === "reset") {
          setInputValue("");
          // Don't update searchTerm — keeps current options visible
          // so user can pick another item from the same results
        } else {
          setInputValue(newInputValue);
          setSearchTerm(newInputValue);
        }
      }}
      onChange={onChange}
      loading={loading}
      getOptionLabel={getOptionLabel}
      options={options}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="standard" />
      )}
    />
  );
};

export default AutoComplete;
